import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import BudgetList from '@app/views/ProjectBudget/List';
import { memo } from 'react';

export default memo(
  withIfUser(BudgetList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
